export const ButtonConstant = {
  defaultH: 60,
  horizontalPadding: 14,
  stroke: 3,
  cornerRadius: 8,
  innerMargin: 8,
  iconSize: 38,
  wordCutoffMargin: 0,
};
